module.exports = __webpack_public_path__ + "static/media/makaut.ba22ba3b.jpg";